import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom'
import React from "react";
import {Card, Tooltip} from "antd";
import CircleChart from "./CircleChart";
import { isEnterpriseUser } from "../../utils/plan-utils";

export class DashboardUsers extends Component {
  handleLinkUsers;
  render() {
    const {
      contractedUsers,
      registeredUsers,
      intl,
      handleShowAddModalUser,
      newColor,
      client,
    } = this.props;

    this.handleLinkUsers = () => {
      this.props.history.push('/home/users')
    }

    const availableUserSpace = registeredUsers < contractedUsers;
    
    return (
      <React.Fragment>
        <Card title={<p onClick={this.handleLinkUsers}>{intl.formatMessage({id: 'users'})}</p>} style={{ paddingBottom: availableUserSpace ? 38: 8}} hoverable className="dashboard-users">
          <div onClick={this.handleLinkUsers} style={{height: "150px", width: "150px", display: "block", margin: "0 auto", marginBottom: 10}}>
            <CircleChart registeredUsers={registeredUsers} totalUsers={contractedUsers}></CircleChart>
          </div>
          <p onClick={this.handleLinkUsers} style={{ color: '#000000', fontWeight: 400, fontSize: 15, }}>{intl.formatMessage({id: 'registered_users'})} {` ${registeredUsers + '/' + contractedUsers}`}</p>
          <h5 style={{color: 'red', marginBottom: 15}}><b>{availableUserSpace ? '':'Ha llegado al limite de usuarios que puede registrar'}</b></h5>
          {!isEnterpriseUser(client.clientType) &&  <div>
            <Tooltip>
              <button className="ant-btn ant-btn-primary" style={{backgroundColor: newColor, borderColor: newColor}} onClick={() => handleShowAddModalUser()}>
                { !isEnterpriseUser(client) ? intl.formatMessage({id: "buy-users"}) : intl.formatMessage({id: "invite_user"})}
              </button>
            </Tooltip>
          </div>}
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  client: state.client.data,
});

export default injectIntl(withRouter(connect(mapStateToProps, {})(DashboardUsers)))
